import { Img } from "./styles";

const Component = (props: any) => {
  return <Img preload {...props} />;
};

export default Component;
